function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 16A8 8 0 118 0a8 8 0 010 16z",
  fill: "#D4E1EE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.699 11.261l4.819-4.82a.961.961 0 00-1.359-1.36l-4.14 4.141-2.178-2.179a.962.962 0 00-1.36 1.36L6.34 11.26a.957.957 0 001.359 0z",
  fill: "#fff"
});

var SvgIconGreencheckNormal = function SvgIconGreencheckNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTZDMy41ODE2IDE2IDAgMTIuNDE4NCAwIDhDMCAzLjU4MTYgMy41ODE2IDAgOCAwQzEyLjQxODQgMCAxNiAzLjU4MTYgMTYgOEMxNiAxMi40MTg0IDEyLjQxODQgMTYgOCAxNloiIGZpbGw9IiNENEUxRUUiLz4KPHBhdGggZD0iTTcuNjk4OTIgMTEuMjYxMkwxMi41MTc5IDYuNDQwNjFDMTIuODk0OCA2LjA2NTE3IDEyLjg5MzggNS40NTY1OCAxMi41MTc5IDUuMDgxMTVDMTIuMTQzNCA0LjcwNjE5IDExLjUzMzkgNC43MDYxOSAxMS4xNTkgNS4wODExNUw3LjAxOTIxIDkuMjIyMDNMNC44NDExNyA3LjA0MzQyQzQuNDY1NzUgNi42Njg0NyAzLjg1NjcxIDYuNjY4NDcgMy40ODE3NiA3LjA0MzQyQzMuMTA2MzQgNy40MTg4NiAzLjEwNjM0IDguMDI4NDEgMy40ODE3NiA4LjQwMjg5TDYuMzM5NTEgMTEuMjYxMkM2LjUyNzQ2IDExLjQ0OTIgNi43NzMxIDExLjU0MjkgNy4wMTkyMSAxMS41NDI5QzcuMjY1MzMgMTEuNTQyOSA3LjUxMDk3IDExLjQ0OTIgNy42OTg5MiAxMS4yNjEyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+";
export { SvgIconGreencheckNormal as ReactComponent };